export default __webpack_public_path__ + "static/media/purchaseSuccessful.96472271.gif";